'use client';

import CarouselModal from '@/components/ui/CarouselModal/CarouselModal';
import ImageView from '@/components/ui/ImageView/ImageView';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useState } from 'react';
import type { LotteryGoodsFileItem } from '../../types';
import styles from './OtherImageList.module.scss';

function OtherImageList({
  images,
}: {
  images: LotteryGoodsFileItem[];
}) {
  const [isScrollModalOpen, setIsScrollModalOpen] = useState(false);
  const [initShowImageUrlIndex, setInitShowImageUrlIndex] = useState(0);
  const urlList = images.map((image) => image.url);

  const handleImageClick = (url: string) => {
    setInitShowImageUrlIndex(urlList.indexOf(url));
    setIsScrollModalOpen(true);
  };

  return (
    <>
      <hr className={`${utilsStyles.mtSmall} ${utilsStyles.pinkishgrayBgColor}`} />
      <div className={`${utilsStyles.textLarge} ${utilsStyles.textBold} ${utilsStyles.mtXSmall} ${styles.title}`}>
        ギャラリー
      </div>
      <div className={styles.componentStyle}>
        {images.map((image) => (
          <div key={image.url} className={styles.imageContainer} onClick={() => handleImageClick(image.url)}>
            <ImageView src={image.url} objectFit='contain' />
          </div>
        ))}
      </div>
      <CarouselModal
        initShowIndex={initShowImageUrlIndex}
        isOpen={isScrollModalOpen}
        close={() => setIsScrollModalOpen(false)}
        childrenArr={urlList.map((url) => <ImageView key={url} src={url} isFreeSize />)}
      />
    </>
  );
}

export default OtherImageList;
